import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container", "removeFlag", "removeBtn"]

  connect() {
    // Snapshot the server-rendered preview at page load so cancel can
    // restore it. For a new car this is empty + no remove button; for
    // an existing car it's the attached cover image + visible button.
    this._initial = {
      html: this.hasContainerTarget ? this.containerTarget.innerHTML : "",
      btnHidden: this.hasRemoveBtnTarget ? this.removeBtnTarget.classList.contains("hidden") : true,
      flag: this.hasRemoveFlagTarget ? this.removeFlagTarget.value : "0"
    }
  }

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) {
      // No file (image-editor cancelled and cleared the input, or the
      // user emptied the picker by other means). Restore the page-load
      // state — for a new car that's empty + no button, for an existing
      // car that's the server-rendered cover + visible button.
      if (this.hasContainerTarget) this.containerTarget.innerHTML = this._initial.html
      if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.toggle("hidden", this._initial.btnHidden)
      if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = this._initial.flag
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.containerTarget.innerHTML = `<img src="${e.target.result}" class="h-32 rounded object-cover" alt="Preview" />`
    }
    reader.readAsDataURL(file)

    // Picking a new file overrides any prior "remove" intent.
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0"
    if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.remove("hidden")
  }

  remove(event) {
    if (event) event.preventDefault()
    // Clear the file input so a stale selection doesn't ride along.
    if (this.hasInputTarget) this.inputTarget.value = ""
    // Drop the preview.
    if (this.hasContainerTarget) this.containerTarget.innerHTML = ""
    // Flip the server-side flag.
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1"
    // Hide the button itself once clicked (nothing left to remove).
    if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.add("hidden")
  }
}
